
import {React, useContext, useState, useEffect } from "react";
import { Outlet } from "react-router";
//import Sidebar from "../../components/Sidebar";
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { useQuery, gql } from '@apollo/client';
import UserContext from '../../../../../context/UserContext';
import ThemeContext from "../../../../../context/ThemeContext";
import { Link, useNavigate } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button"; 
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import "../../../../../index.css"
import HtlSalesPlanEdit from './HtlSalesPlanEdit'
//import AgencyCreateCoop from './AgencyCreateCoop'
import { Dialog } from 'primereact/dialog';
import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
//import HtlHotelRoomTypeCreate from "./HtlHotelRoomTypeCreate";
import { RadioButton } from "primereact/radiobutton";
import { FilterMatchMode, FilterOperator } from 'primereact/api';


import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';
        




//theme
import "primereact/resources/themes/tailwind-light/theme.css";     
    
//core
import "primereact/resources/primereact.min.css";                                       
        


const GET_POST = gql`
  query GetFilteredFirms(
    $FirmMainCode: String
    $FirmSubCode: String
    $currentLocale: String
    $contType: String
    
    
  ) {
    tbl_cont_prn(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $FirmMainCode }
        firm_sub_code: { _eq: $FirmSubCode }
        cont_type: { _eq: $contType }
        
       
      }
    ) {
        firm_main_code
        firm_sub_code
        firm_sub_name {
          firm_sub_name
        }
        get_main_firm_name_k {
          firm_main_name_n
        }
        firm_sub_code_k
        firm_sub_name_k {
          firm_sub_name_n
        }
        id_seq
        active
        cont_type
        created_at
        get_cont_type_name(where: { lang: { _eq: $currentLocale } }) {
          name
          lang
          type
        }
     
      }
    }
  
`;








const HtlSalesPlantList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { users } = useContext(UserContext);
  const {varCode4, setVarCode4} = useContext(ThemeContext);
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  
  const FirmMainCode = users.firmcode;
  const FirmSubCode = users.subfirmcode;
  const contType = 'HSP';
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: {
      FirmMainCode,
      FirmSubCode,
      currentLocale,
      contType,
      
    },
  });

  const navigate = useNavigate();

  
  
 

  const close_form = messages[currentLocale].close_form;
  const create_room_classrec = messages[currentLocale].create_room_classrec;
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const room_class_code = messages[currentLocale].room_class_code;
  const typerec = messages[currentLocale].typerec;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create = messages[currentLocale].create;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const position = messages[currentLocale].position;
  const dashboard = messages[currentLocale].dashboard;
  const room_class_tab = messages[currentLocale].room_class_tab;
  const cont_id_title = messages[currentLocale].cont_id_title;
  const hotel_sub_title = messages[currentLocale].cont_hotel_sub_title;
  const cont_agency_main_title = messages[currentLocale].cont_agency_main_title;
  const cont_agency_sub_title = messages[currentLocale].cont_agency_sub_title;
  const cont_type_title = messages[currentLocale].cont_type_title;
  const sales_office_title = messages[currentLocale].sales_office_title;
  const price_title = messages[currentLocale].price_title;
  const cont_management_title = messages[currentLocale].cont_management_title;
  const cont_new_button = messages[currentLocale].cont_new_button;
  


  const items = [{ label: dashboard ,url: "/", target: '_self'}, { label: sales_office_title ,url:"htl/sales-office/main" }, { label: price_title  }, { label: cont_management_title  }];


 

  const [active, setActive] = useState(true);



  
 
  
  const [displayBasic, setDisplayBasic] = useState(false);
 
  console.log(users.firmcode);
  console.log(data);

  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0); // first1'i tanımlayın ve başlangıç değeri ayarlayın

const onRowsPerPageChange = (e) => {
  setRows1(e.value); // Görünen kayıt sayısını değiştir
  setFirst1(0); // İlk sayfadan başla
};

const onPageChange = (e) => {
  setFirst1(e.first);
  setRows1(e.rows1);
}

const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />; // paginatorLeft'i tanımlayın
const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />; // paginatorRight'ı tanımlayın

  
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const filteredFirms = data.tbl_cont_prn.filter((firm) =>
  firm.firm_sub_name_k.some((nameObj) =>
    nameObj.firm_sub_name_n.toLowerCase().includes(searchTerm.toLowerCase())
  )
);


  const actionTemplate = (rowData) => {
    setVarCode4(rowData.id_seq)
    refetch();
    return (
      <Link to={`/htl/sales/price/htlsalesplanedit/${rowData.id_seq}`}>
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
      </Link>
      
    );
      };
      
      
      const onClick = (id_seq) => {
     //   window.location.href = `/htl/sales/price/htlagncontract/${idSeq}`;

    // <Route path="/htl/sales/price/htlagncontract/:id_seq" element={<HtlAgnContractEdit />} />
    setVarCode4(11);
    navigate(`/htl/sales/price/htlsalesplanedit/${id_seq}`);
    

     //navigate(`/htl/sales/price/htlagncontractnew/`);
      
     //<Link to={`/htl/sales/price/htlagncontract/${id_seq}`}></Link>
      };

      const onClick2 = () => {
        
       
        refetch();
      };
      
      const onHide = () => {
        setDisplayBasic(false);
        refetch();
        
      };



  const userAndCreatedAtTemplate = (rowData) => {
    return (
      <div>
        <div className="text-xs">{rowData.create_user}</div>
        <div className="text-xs">{rowData.created_at}</div>
      </div>
    );
  };

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-xs"
      : "text-gray-500 font-bold text-xs";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };

 



  const getStatusLabel2 = (options) => {
    return (
      <div className="ml-5 flex-col font-medium flex justify-content-center p-column-filter">
        <label
          htmlFor="firmtype"
          className="flex-col w-1/12 ml-0 mb-4 align-items-center block font-medium text-gray-950"
        >
         {statusrec}
        </label>
        <p></p>
        <div className="flex ml-0 flex-wrap gap-6">
          <div className="flex ml-0 align-items-center">
            <RadioButton
              inputId="ingredient1"
              name="active"
              value={true}
              onChange={(e) => {
                const filterValue = e.value ? "true" : "false";
                options.filterApplyCallback(filterValue);
                setActive(e.value);
              }}
              checked={active === true}
            />
            <label htmlFor="ingredient1" className="ml-2">
              {activerec}
            </label>
          </div>
          <div className="flex align-items-center">
            <RadioButton
              inputId="ingredient2"
              name="inactive"
              value={false}
              onChange={(e) => {
                const filterValue = e.value ? "true" : "false";
                options.filterApplyCallback(filterValue);
                setActive(e.value);
              }}
              checked={active === false}
            />
            <label htmlFor="ingredient2" className="ml-2">
              {inactiverec}
            </label>
          </div>
        </div>
      </div>
    );
  };
        

  const filterElement = getStatusLabel2({
    filterApplyCallback: (value) => {
      // value, seçilen RadioButton'un değeridir (true veya false).
      // Bu değeri kullanarak başka bir şey yapabilirsiniz, örneğin bir state'i güncelleyebilirsiniz.
      setActive(value);
    },
  });




  return (

    

    
    
    
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="flex justify-between items-center">
      <nav>
        <ul className="flex border-solid mt-3 rounded-md border-b outline-1 mb-5">
          {items.map((item, index) => (
            <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
              {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
              {item.url ? (
                <Link to={item.url}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <button onClick={() => navigate(-1)} className="flex text-violet-900 hover:text-violet-200 font-bold">
        {close_form}
      </button>
    </div>
    
  

<div>
  
<Dialog visible={displayBasic} style={{ width: '60vw' }} onHide={onHide} header={room_class_tab}>
  <div className={`modal-backdrop bg-slate-600  ${displayBasic ? 'block' : 'hidden'}`}></div>
  <div>
    <p>
   
    </p>
  </div>
</Dialog>
</div>
          
<div className="card flex ">      
<div className="container p-2 mx-auto ">
      <div className=" w-1/1 text-gray-950 flex gap-4">
        <input
          type="text"
          className="px-2 py-1 border rounded-md"
          placeholder={search_by_name}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      

      <div className="mt-0 flex  w-full justify-end ">
      <Button
      label={cont_new_button}
      aria-label="Create"
      className="p-button-sm p-button-outlined bg-purple-800 hover:bg-purple-950 text-white font-semibold rounded-md"
      onClick={() => onClick(11)}  // İstediğiniz idSeq değerini burada belirtin
    />
        </div>
        </div></div></div>
      <div>
      <div className="card p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
        <DataTable
        scrollable scrollHeight="450px" loading={loading}
        value={filteredFirms}
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={currentPageReportTemplate}
        rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
        rowsPerPageOptions={[10, 20, 50]}
        first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
        onPage={(e) => setFirst1(e.first)} 
        onRowsPerPageChange={(e) => setRows1(e.value)}
      //  paginatorLeft={paginatorLeft}
      //  paginatorRight={paginatorRight}
        tableStyle={{ minWidth: '50rem',  maxHeight: '40rem' }}
        onPageChange={onPageChange}
        globalFilterFields={false}
       
        
       
        
        >
          <Column className="font-bold text-xs" field="id_seq" style={{ textAlign: 'left', width: '10rem' }} header={cont_id_title}></Column>
          <Column className="font-bold text-xs" field="firm_main_code" style={{ textAlign: 'left', width: '10rem' }} header={main_code}></Column>
          <Column className="text-xs" field="firm_sub_code" style={{ textAlign: 'left', width: '10rem' }} header={<span sortable className="font-bold text-gray-900">{sub_code}</span>}></Column>
         
          <Column
           className="text-xs"
           field="firm_sub_name"
           style={{ textAlign: 'left', width: '20rem' }}
           header={<span className="font-bold text-gray-900">{hotel_sub_title}</span>}
           body={(rowData) => (
           <span>
           {rowData.firm_sub_name.map((nameObj) => nameObj.firm_sub_name).join(', ')}
          </span>
            )}
           />
           <Column
           className="text-xs"
           field="firm_main_name_n"
           style={{ textAlign: 'left', width: '20rem' }}
           header={<span className="font-bold text-gray-900">{cont_agency_main_title}</span>}
           body={(rowData) => (
           <span>
           {rowData.get_main_firm_name_k.map((nameObj) => nameObj.firm_main_name_n).join(', ')}
          </span>
            )}
           />
              <Column
           className="text-xs"
           field="firm_sub_name_n"
           style={{ textAlign: 'left', width: '20rem' }}
           header={<span className="font-bold text-gray-900">{cont_agency_sub_title}</span>}
           body={(rowData) => (
           <span>
           {rowData.firm_sub_name_k.map((nameObj) => nameObj.firm_sub_name_n).join(', ')}
          </span>
            )}
           />
          
          <Column field="cont_type"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{typerec}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          />
           <Column
           className="text-xs"
           field="name"
          
           style={{ textAlign: 'left', width: '20rem' }}
           header={<span className="font-bold text-gray-900">{cont_type_title}</span>}
           body={(rowData) => (
           <span>
           {rowData.get_cont_type_name.map((nameObj) => nameObj.name).join(', ')}
          </span>
            )}
           />
          
          <Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">{create}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.created_at;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} ${dateObj.toLocaleTimeString('en-GB')}`;
            const createUser = rowData.create_user;

          return (
           <div className="text-xs">
           {createUser}  {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

           <Column
            field="active"
            
            
            
           
            filter 
            showFilterMatchModes={false}
            filterField="active"
            
            filterElement={getStatusLabel2}
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{statusrec}</span>}
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs " 
          />
         <Column
            body={actionTemplate}
            header={<span className="font-bold text-gray-900">{detail}</span>}
            
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs" 
          />
    
        </DataTable>
        
      </div>
    </div>
    </div>
 
  );
};

export default HtlSalesPlantList;


